import type { ReportCadence } from './api';

/** O nome da cadência na tela: a API fala inglês, o painel fala português. */
export class ReportCadenceLabel {
  private static readonly LABELS: Record<ReportCadence, string> = {
    daily: 'Relatório diário dos vendedores',
    weekly: 'Relatório semanal dos vendedores',
  };

  static of(cadence: ReportCadence): string {
    return ReportCadenceLabel.LABELS[cadence];
  }

  static options(): { cadence: ReportCadence; label: string }[] {
    return (Object.keys(ReportCadenceLabel.LABELS) as ReportCadence[]).map((cadence) => ({
      cadence,
      label: ReportCadenceLabel.LABELS[cadence],
    }));
  }
}
